import React from 'react'
import Navbar from '../../components/navbar'
import Fulltime from './fulltime'
import Sec1 from './sec1'

const Careers = () => {
  return (
    <div className='section-nav careers'>
      <Navbar />
      <div className='careers-banner'>
        <div className='head'>Career</div>
        <p>Build your career with us</p>
      </div>

      <div className='career-container'>
        <Sec1 />
        <Fulltime />
      </div>
    </div>
  )
}

export default Careers
